import { useState, useEffect, useMemo } from 'react';
import * as tnaServices from '../services/tnaServices';
import { pad2 } from '../services/utils/tna';

function useTnaModule(tnaModuleId) {
  console.log(tnaModuleId);
  
  const [moduleDetails, setModuleDetails] = useState({});
  const [allAtas, setAllAtas] = useState([]);
  const [isForDiff, setIsForDiff] = useState(false);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  // load ATAs (static list)
  useEffect(() => {
    let ac = new AbortController();
    tnaServices.getOption('getAllAtas')
      .then((res) => {
        if (!ac.signal.aborted) setAllAtas(res.data || []);
      })
      .catch((e) => !ac.signal.aborted && console.error('Error fetching ATAs:', e));
    return () => ac.abort();
  }, []);

  // load module
  useEffect(() => {
    if (!tnaModuleId) return;
    let ac = new AbortController();
    setLoading(true);
    tnaServices
      .getModuleById(tnaModuleId)
      .then((res) => {
        if (ac.signal.aborted) return;
        const md = res.data?.[0] || {};
        setModuleDetails(md);
        setIsForDiff(md?.tnaModuleIsForDiff === 1);
        setLoading(false);
      })
      .catch((e) => {
        if (!ac.signal.aborted) {
          console.error('Error fetching TNA Module details:', e);
          setErr(e);
          setLoading(false);
        }
      });
    return () => ac.abort();
  }, [tnaModuleId]);

  // derived
  const ataById = useMemo(() => {
    const map = new Map();
    (moduleDetails.ata || []).forEach(a => map.set(a.ataId, a));
    return map;
  }, [moduleDetails.ata]);

  // total duration (HH:MM)
  const totalDuration = useMemo(() => {
    const list = moduleDetails.ata || [];
    if (!list.length) return '00:00';

    let totalSeconds = 0;
    for (const a of list) {
      if (!a?.duration) continue;
      const [h, m, s = '0'] = a.duration.split(':').map(Number);
      totalSeconds += (h || 0) * 3600 + (m || 0) * 60 + (s || 0);
    }
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    return `${pad2(hours)}:${pad2(minutes)}`;
  }, [moduleDetails.ata]);

  return { moduleDetails, setModuleDetails, allAtas, isForDiff, loading, error: err, ataById, totalDuration };
}

export default useTnaModule;